var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36ABFF",
    fillRule: "evenodd",
    d: "M2.667 1.333A.667.667 0 0 0 2 2v7.333c0 .368.298.667.667.667h4v4c0 .368.298.667.666.667h6A.667.667 0 0 0 14 14V8.667a.666.666 0 0 0-.195-.472l-2-2A.667.667 0 0 0 11.333 6h-2V4a.667.667 0 0 0-.195-.471l-2-2a.667.667 0 0 0-.471-.196h-4ZM8 6V4.276l-1.61-1.61H3.334v6h3.334V7.334h-2a.667.667 0 1 1 0-1.333H8Zm0 7.333v-6h3.057l1.61 1.61v4.39H8Zm.667-4c0-.368.298-.666.666-.666h2a.667.667 0 1 1 0 1.333h-2a.667.667 0 0 1-.666-.667ZM4.667 4a.667.667 0 0 0 0 1.333H6A.667.667 0 1 0 6 4H4.667Zm4 7.333c0-.368.298-.666.666-.666h2a.667.667 0 0 1 0 1.333h-2a.667.667 0 0 1-.666-.667Z",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;